var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.35,
    height: 19.55,
    viewBox: "9.983 6.983 14.35 19.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6 15.461h-1.3v-2.604A5.834 5.834 0 0 1 17.157 7c2.929 0 5.468 2.211 5.792 5.14l-1.3.13c-.26-2.277-2.212-3.97-4.492-3.97a4.528 4.528 0 0 0-4.556 4.557v2.604Z",
    fill: "#333",
    fillRule: "evenodd",
    "data-name": "Path 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.362 26.523h-10.41A1.918 1.918 0 0 1 10 24.571v-7.81c0-1.105.847-1.952 1.952-1.952h10.414c1.106 0 1.952.847 1.952 1.952v7.81c-.004 1.105-.85 1.952-1.956 1.952Zm-10.41-10.414c-.388 0-.652.26-.652.652v7.81c0 .388.26.651.652.651h10.414c.389 0 .652-.259.652-.651v-7.81c0-.389-.26-.652-.652-.652H11.952Z",
    fill: "#333",
    fillRule: "evenodd",
    "data-name": "Path 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.857 18.614a1.3 1.3 0 1 1 0 .1z",
    fill: "#333",
    fillRule: "evenodd",
    "data-name": "Ellipse 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.481 18.714h-.648l-.652 3.904h1.952l-.652-3.904Z",
    fill: "#333",
    fillRule: "evenodd",
    "data-name": "Path 46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock-icon.db79ed26a1701ea1b90ac3d6a5dce6ea.svg";
export { ForwardRef as ReactComponent };